import $ from 'jquery';
import { Field } from 'redux-form';
import Modal from 'praece-react-bootstrap/lib/Modal';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

import { LONG_HUMAN_DATE_FORMAT } from 'constants';
import { SimpleReduxForm } from 'components/forms/form-structure';
import { SubmitButton, SecondaryButton } from 'components/widgets/buttons';
import { TextAreaInput } from 'components/forms/form-elements';
import { alerts } from 'modules/alerts/actions';
import { focusInputStart } from 'utils/input-utils';
import CompanyNickname from 'components/models/company/company-nickname';
import Ticket from 'services/data/ticket';
import TicketLink from 'components/models/ticket/ticket-link';
import TimeReport from 'services/data/time-report';
import requiredValidation from 'utils/required-validation';


export default class ClosingLastTask extends React.Component {
  static propTypes = {
    show: PropTypes.bool,
    ticket: PropTypes.object.isRequired,
    saveNewTask: PropTypes.func.isRequired,
    updateTask: PropTypes.func.isRequired,
    updateTicket: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired
  };

  constructor() {
    super();

    this.state = { checkedTimeReport: false };
    this.resolveTicket = this.resolveTicket.bind(this);
    this.addTask = this.addTask.bind(this);
    this.cancelCloseTicket = this.cancelCloseTicket.bind(this);
    this.close = this.close.bind(this);
  }

  componentWillMount() {
    TimeReport.count({ where: { ticket: this.props.ticket.id } })
      .then(count => {
        if (count !== 1) {
          this.setState({ checkedTimeReport: true });
        } else {
          TimeReport.find({ where: { ticket: this.props.ticket.id } })
            .then(reports => this.setState({ checkedTimeReport: true, timeReportDescription: reports[0].description }));
        }
      });
  }

  componentDidMount() {
    if (this.state.checkedTimeReport) focusInputStart($('.closing-last-task-modal textarea')[0]);
  }

  resolveTicket(values) {
    const { ticket } = this.props;

    Ticket.update({
      id: ticket.id,
      resolution: values.resolution,
      tasks: [{
        id: ticket.lastClosedTaskId,
        status: 'Complete'
      }]
    })
      .then(this.close)
      .then(() => {
        alerts.success({
          title: 'Ticket closed!',
          subtitle: <TicketLink ticket={ticket} hideOnRouteMatch>View ticket</TicketLink>
        });
      })
      .catch(alerts.catchError);
  }

  addTask() {
    this.close();

    const { ticket } = this.props;

    this.props.saveNewTask('Re-task')
      .then(() => Ticket.update({
        id: ticket.id,
        tasks: [{
          id: ticket.lastClosedTaskId,
          status: 'Complete'
        }]
      }))
      .catch(alerts.catchError);
  }

  cancelCloseTicket() {
    const { ticket } = this.props;
    const task = _.find(ticket.tasks, { id: ticket.lastClosedTaskId });

    this.props.updateTask(
      { status: 'Active', ..._.pick(task, ['id', 'uuid', 'ticket']) },
      { showClosingLastTaskModal: true, lastClosedTaskId: task.id }
    );
    this.close();
  }

  close() {
    const { ticket } = this.props;

    this.props.updateTicket({ showClosingLastTaskModal: false, lastClosedTaskId: null, id: ticket.id });
  }

  render() {
    const { ticket } = this.props;
    const { checkedTimeReport, timeReportDescription } = this.state;
    let resolution = '';

    if (ticket.resolution && ticket.closedAt) {
      resolution = `\n\n[Previous resolution ${moment(ticket.closedAt).format(LONG_HUMAN_DATE_FORMAT)}]\n${ticket.resolution}`;
    }

    if (timeReportDescription) {
      resolution = `${timeReportDescription} ${resolution}`;
    }

    if (!checkedTimeReport) return null;

    return (
      <Modal show={ticket.showClosingLastTaskModal} className="closing-last-task-modal" animation>
        <Modal.Header>
          <Modal.Title>
            Closing Ticket: {ticket.description}
          </Modal.Title>
          <CompanyNickname company={ticket.company} noLink />
        </Modal.Header>
        <SimpleReduxForm
          onSubmit={this.resolveTicket}
          form={`resolve-ticket-${ticket.id}`}
          validate={values => requiredValidation(['resolution'], values)}
          initialValues={{ resolution }}
          preventAutoFocus
          customSubmitArea
        >
          <Modal.Body>
            <div className="oops-section">
              <p>You just closed the last task for this ticket!</p>
              <SecondaryButton onClick={this.cancelCloseTicket}>Oops, re-open task</SecondaryButton>
              <SecondaryButton onClick={this.addTask}>Oops, add another task</SecondaryButton>
            </div>
            <div>
              <p>
                If this ticket is resolved, tell us how you resolved it— provide enough detail that someone outside your team would understand the fix.
              </p>
              { resolution &&
                <p className="remember">
                  This ticket has been resolved before. The previous resolution has been included below for you to edit or replace.
                </p>
              }
              <Field component={TextAreaInput} name="resolution" label="Ticket resolution" />
              <div className="input-help-text">
                Example:
                <p className="examples">
                  Deleted PerfectLaw plugin from Outlook COM plugins, re-added using the latest plugin provided by PerfectLaw. The latest plugin is available at /company/it/perfectlaw/plugins/outlook2016.dll
                </p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <SubmitButton content="Resolve" />
          </Modal.Footer>
        </SimpleReduxForm>
      </Modal>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/models/ticket/closing-last-task.js